import { Button, useModal } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../enums/modalId'

export const BookkeepersSectionSideActions = (): ReactElement => {
  const { t } = useTranslation()
  const { open: openInviteBookkeeperModal } = useModal(ModalId.OrganizationSettingsInviteBookkeeper)

  const handleInviteBookkeeperButtonClick = useCallback(() => {
    openInviteBookkeeperModal()
  }, [openInviteBookkeeperModal])

  return (
    <Button icon="circlePlus" onClick={handleInviteBookkeeperButtonClick}>
      {t('settings.organization.users.invite_section.invite_bookkeeper')}
    </Button>
  )
}
